import { createAction } from 'redux-actions';
export var fetchArtAuthor = createAction('ART_BRANDED_POPUP.FETCH_ART_AUTHOR');
export var fetchArtAuthorSuccess = createAction('ART_BRANDED_POPUP.FETCH_ART_AUTHOR_SUCCESS');
//# sourceMappingURL=actions.js.map